export interface Employee {
  id: number;
  name: string;
  active: boolean;
}
export const employeeSeed = (): Employee[] => [
  { id: 7, name: 'Asha', active: true },
  { id: 8, name: 'Leo', active: false },
];

export function employeeInput(text: string): { name: string; active: boolean } | string {
  let input: unknown;
  try {
    input = JSON.parse(text) as unknown;
  } catch {
    return 'Syntax error: the body is not valid JSON.';
  }
  if (!input || typeof input !== 'object' || Array.isArray(input))
    return 'Schema error: expected an object.';
  const value = input as Record<string, unknown>;
  if (Object.keys(value).some((key) => !['name', 'active'].includes(key)))
    return 'Schema error: unexpected field.';
  if (typeof value.name !== 'string') return 'Schema error: name must be a string.';
  // Match Python str.strip, including its additional ASCII information separators.
  const name = value.name.replace(
    // eslint-disable-next-line no-control-regex -- Python treats these whitespace controls as trim characters.
    /^[\u0009-\u000d\u001c-\u0020\u0085\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000]+|[\u0009-\u000d\u001c-\u0020\u0085\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000]+$/gu,
    '',
  );
  if (!name || [...name].length > 80)
    return 'Schema error: trimmed name must contain 1–80 characters.';
  if ('active' in value && typeof value.active !== 'boolean')
    return 'Schema error: active must be a boolean.';
  return { name, active: value.active === undefined ? true : (value.active as boolean) };
}

export function httpExchange(
  rows: Employee[],
  method: string,
  path: string,
  body: string,
  running: boolean,
) {
  if (!running) return { status: null, body: 'No HTTP response: connection refused.', rows };
  const collection = path === '/api/employees';
  const id = Number(path.split('/').at(-1));
  const record = rows.find((row) => row.id === id);
  if (method === 'GET')
    return collection
      ? { status: 200, body: rows, rows }
      : record
        ? { status: 200, body: record, rows }
        : { status: 404, body: { detail: 'Employee not found' }, rows };
  if (method === 'POST' && collection) {
    const input = employeeInput(body);
    if (typeof input === 'string') return { status: 422, body: { detail: input }, rows };
    const created = { id: Math.max(8, ...rows.map((row) => row.id)) + 1, ...input };
    return { status: 201, body: created, rows: [...rows, created] };
  }
  if (method === 'DELETE' && !collection)
    return record
      ? { status: 204, body: null, rows: rows.filter((row) => row.id !== id) }
      : { status: 404, body: { detail: 'Employee not found' }, rows };
  if (method === 'PATCH' && !collection) {
    if (!record) return { status: 404, body: { detail: 'Employee not found' }, rows };
    const updated = { ...record, active: !record.active };
    return { status: 200, body: updated, rows: rows.map((row) => (row.id === id ? updated : row)) };
  }
  return { status: 405, body: { detail: 'Method Not Allowed' }, rows };
}
